import { useLazyQuery } from '@apollo/client';
import { query } from './query';
export function useComposer(composerId) {
    const [getComposer, { loading, data }] = useLazyQuery(query, { variables: { composerId } });
    return { getComposer, loading, data };
}
